import { useMutation } from "react-query";
import z from "zod";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { DistanceModeApiSchema, RouteGeometrySchema } from "./useTransportLegs";

const TransportRoutePreviewSchema = z.object({
    distanceKm: z.number(),
    distanceMode: DistanceModeApiSchema,
    routeGeometry: RouteGeometrySchema,
});

export type TransportRoutePreview = z.infer<typeof TransportRoutePreviewSchema>;

export type TransportRoutePreviewInput = {
    transportModeId: number;
    originLatitude: number;
    originLongitude: number;
    destinationLatitude: number;
    destinationLongitude: number;
};

export const useComputeTransportRoutePreview = () => {
    return useMutation({
        mutationFn: async (input: TransportRoutePreviewInput) => {
            const response = await loggedInApiCall.post("/api/transport-legs/compute-route-preview", input);
            return zodParseWithLog(response.data, TransportRoutePreviewSchema, "useComputeTransportRoutePreview");
        },
    });
};
